<template>
  <MarketInsightsPage
    v-slot="{ slug, categoriesArticles, playVideo }"
    :market="SYNTHETIC_GRAPHITE"
  >
    <NuxtPage
      :slug="slug"
      :categories-articles="categoriesArticles"
      :categories-videos="categoriesArticles"
      @play-video="playVideo"
    />
  </MarketInsightsPage>
</template>

<script setup lang="ts">
import MarketInsightsPage from '~/components/market/MarketInsightsPage.vue'
import { SYNTHETIC_GRAPHITE, MARKET } from '~/constants/services/constants'

const { getSeoInfo } = useSeo()
const seo = getSeoInfo({
  title: `${MARKET.name}: ${SYNTHETIC_GRAPHITE.name} Market Insights`,
})

useHead(seo)

definePageMeta({ layout: 'services' })
</script>
